import {
  createStore, applyMiddleware, combineReducers, compose,
} from 'redux';
import thunk from 'redux-thunk';
import { localizeReducer as localize } from 'react-localize-redux';
import { createFetchReducer } from '@trdk/style/Redux';
import submitReducer from './components/submit/submit.reducer';

const getInitialForm = () => {
  try {
    const localForm = localStorage.getItem('form');
    if (localForm !== null) {
      const parsedForm = JSON.parse(localForm, JSON.dateParser);
      return parsedForm;
    }
    return false;
  } catch (e) {
    return false;
  }
};

const rootReducer = combineReducers({
  localize,
  form: submitReducer,
  isLoggedIn: createFetchReducer('IS_LOGGEDIN', undefined, false),
  profile: createFetchReducer('PROFILE', undefined, {}),
  licenses: createFetchReducer('LICENSES', undefined, []),
  assignments: createFetchReducer('ASSIGNMENTS', undefined, []),
  controllers: createFetchReducer('CONTROLLERS', undefined, []),
  control: createFetchReducer('CONTROL', undefined, {}),
  licenseControls: createFetchReducer('LICENSE_CONTROLS', undefined, {}),
  licenseReactions: createFetchReducer('LICENSE_REACTIONS', undefined, {}),
  workPlanControls: createFetchReducer('WORK_PLAN_CONTROLS', undefined, {}),
});

// enable redux dev-tools
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const create = () => {
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

  return store;
};

const store = create();

export default store;
export { getInitialForm };
